import { clsx } from '../../../ds/clsx';
import styles from './WizardHeader.module.css';

export interface WizardHeaderStep {
  key: string;
  label: string;
  /** Server status of the step: `done` draws the check, everything else the number. */
  status: string;
}

export interface WizardHeaderProps {
  steps: readonly WizardHeaderStep[];
  currentKey: string | null;
  /** Right-aligned name of the signed-in person („M. Osterloh · Administration"). */
  userLabel: string;
}

/** 72 px header of the wizards (Admin 03–10, Nutzer 02–11): wordmark, numbered circles, user label. */
export function WizardHeader({ steps, currentKey, userLabel }: WizardHeaderProps) {
  return (
    <header className={styles.header}>
      <span className={styles.wordmark}>DAMOKLES</span>
      <ol className={styles.steps} aria-label="Schritte der Einrichtung">
        {steps.map((step, index) => {
          const current = step.key === currentKey;
          const done = !current && step.status === 'done';
          return (
            <li key={step.key} className={styles.stepItem}>
              {index > 0 ? <span className={styles.connector} aria-hidden="true" /> : null}
              <span
                className={clsx(styles.step, current && styles.current, done && styles.done)}
                aria-current={current ? 'step' : undefined}
              >
                <span className={styles.circle} aria-hidden="true">
                  {done ? '✓' : index + 1}
                </span>
                <span className={styles.stepLabel}>{step.label}</span>
                {done ? <span className={styles.srOnly}> · erledigt</span> : null}
              </span>
            </li>
          );
        })}
      </ol>
      <span className={styles.user}>{userLabel}</span>
    </header>
  );
}
